import type { TCsvType } from 'App/data-export/components/_utils/createAndDownloadCsvIfApplicable/createCsv'
import { translate } from 'i18n/i18n'

export const mapCsvTypeToFieldAssetNameColumnHeader: Record<TCsvType, () => string> = {
  blocks: () => translate.phrases.banyanApp('Block'),
  irrigationZones: () => translate.phrases.banyanApp('Irrigation Zone'),
  points: () => translate.phrases.banyanApp('Device'),
}
